import React from 'react';
import ApproveButton from '../Buttons/ApproveRejectButton';
import SaveButton from '../Buttons/SaveButton';

const FeatureCard = ({
  title,
  description,
  onClickHandler,
  component_styles,
  onMarkAsComplete,
  onClickSkip,
}) => {
  return (
    <div
      className={`border  border-gray-200 rounded w-full px-4 md:px-8 py-4 pb-[60px] flex items-center gap-4 bg-[#FAFBFB] ${component_styles} relative`}>
      <div className="flex-grow  ">
        <h1 className=" font-extralight  text-sm md:text-lg text-black">
          {title}
        </h1>
        <p className="   text-xs md:text-base font-normal text-gray-700">
          {description}
        </p>
      </div>

      <div className=" absolute   left-4 md:left-8 bottom-4 flex items-center justify-start gap-2 ">
        <ApproveButton
          onClickButton={onClickSkip}
          is_approve={true}
          title={'Skip'}
        />
        <ApproveButton
          onClickButton={onMarkAsComplete}
          is_approve={true}
          title={'Mark as Completed'}
        />

        <SaveButton
          onClickButton={onClickHandler}
          is_approve={true}
          title={'Try Now'}
        />
      </div>
    </div>
  );
};

export default FeatureCard;
